import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy: React.FC = () => (
  <section className="pt-36 pb-24 bg-[#080808] min-h-screen">
    <div className="max-w-3xl mx-auto px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <p className="section-label mb-4">Legal</p>
        <h1 className="font-serif text-5xl text-white mb-8">Privacy Policy</h1>
        <div className="font-dm text-[#999] text-sm leading-loose space-y-6">
          <p>SiteStackCo ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your information when you visit our website.</p>
          <p><span className="text-white font-syne font-semibold">Information We Collect:</span> We collect information you voluntarily provide through our contact form, including your name, email address, phone number, and project details.</p>
          <p><span className="text-white font-syne font-semibold">How We Use Your Information:</span> We use your information to respond to inquiries, provide our services, and improve your experience with SiteStackCo.</p>
          <p><span className="text-white font-syne font-semibold">Cookies:</span> We use cookies to enhance your browsing experience and analyze site traffic. You may choose to decline cookies.</p>
          <p><span className="text-white font-syne font-semibold">Contact:</span> For privacy inquiries, email us at Create@SiteStackCo.com.</p>
          <p className="text-[#777] text-xs">Last updated: {new Date().getFullYear()}</p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default PrivacyPolicy;
